import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { CheckboxProps } from './types';
import { styles } from './styles';
import { generateFieldId } from '@v2/lib';

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  indeterminate = false,
  className,
}) => {
  const checkboxRef = useRef<HTMLInputElement>(null);
  const checkboxId = id || generateFieldId(label);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div className={clsx(styles.container, className)}>
      <input
        ref={checkboxRef}
        type="checkbox"
        id={checkboxId}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={styles.checkbox}
      />
      <label htmlFor={checkboxId} className={clsx(styles.label, disabled && styles.labelDisabled)}>
        {label}
      </label>
    </div>
  );
};

export type { CheckboxProps } from './types';
export default Checkbox;
